// Import testimonial images
import alexeyImg from '../assets/testimonial/alexeyscreen.png';
import sohaibImg from '../assets/testimonial/sohaibscreen.png';
import furqanImg from '../assets/testimonial/Sebastian.jpg';

import exp1 from '../assets/experinceimp/exp1.png';
import exp2 from '../assets/experinceimp/exp2.png';
import exp4 from '../assets/experinceimp/exp4.png';
import exp6 from '../assets/experinceimp/exp6.png';
import logo1 from '../assets/experinceimp/logo1.png';
import logo2 from '../assets/experinceimp/logo2.png';
import logo4 from '../assets/experinceimp/logo4.png';
import logo6 from '../assets/experinceimp/logo6.png';


import {
  fullstack,
  data_scientist,
  leadership,
  ai,
  javascript,
  api,
  ai_logo,
  python,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  figma,
  docker,
  meta,
  starbucks,
  tesla,
  shopify,
  chopcast,
  jobit,
  nzdpu,
  threejs,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "experience",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "AI/ML Engineer",
    icon: ai,
  },
  {
    title: "Data Scientist",
    icon: data_scientist,
  },
  {
    title: "Full Stack Developer",
    icon: fullstack,
  }, 
  {
    title: "Team Lead",
    icon: leadership,
  },
];

const technologies = [
  {
    name: "AI/ML",
    icon: ai_logo,
  },
  {
    name: "Python",
    icon: python,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "Api",
    icon: api,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "Three JS",
    icon: threejs,
  },
  {
    name: "git",
    icon: git,
  },
  {
    name: "Next JS",
    icon: figma,
  },
  {
    name: "docker",
    icon: docker,
  },
];

const expCards = [
  {
    review: "ReductStore is a German software company that builds high performance data storage and streaming systems for robotics, industrial IoT, and real time analytics. The platform is engineered to handle massive volumes of time indexed machine data with ultra fast ingestion, retrieval, and reliability. As a Software Engineer at ReductStore, I contributed to developing scalable backend services, client SDKs, cloud infrastructure, and data centric tools that power low latency AI and automation pipelines for enterprise customers.",
    imgPath: exp1,
    logoPath: logo1,
    title: "Senior Software Engineer",
    date: "February 2025 - Present",
    responsibilities: [
      "Led the development of scalable backend services, client SDKs, and cloud native components powering ReductStore’s high performance data platform.",
      "Built and optimized real time data infrastructure using FastAPI, PostgreSQL, Firebase, AWS S3, and Google Cloud, ensuring low latency ingestion and reliable large scale data processing.",
      "Collaborated across teams to deliver core platform features, enhance the Web Console and CI/CD pipelines, and improve system stability, performance, and user experience.",
    ],
  },
  {
    review: "Artilence is an innovative AI software company based in Lahore that specialises in building intelligent automation and data driven solutions for enterprise clients. Their platform leverages advanced cloud infrastructure, real time data pipelines and AI/ML models to help businesses streamline operations, extract actionable insights, and deliver high performance digital products. As a Software Engineer at Artilence, I contributed to architecting and delivering scalable backend services, full stack modules and machine learning pipelines that power the next generation of intelligent applications.",
    imgPath: exp2,
    logoPath: logo2,
    title: "Software Engineer",
    date: "2023 - 2025",
    responsibilities: [
      "Led the development of Docker's web applications, focusing on scalability.",
      "Worked with backend engineers to integrate APIs seamlessly with the frontend.",
      "Contributed to open source projects that were used with the Docker ecosystem.",
    ],
  },
   {
    review: "InvoZone is a global software development company that provides end to end engineering services in AI, cloud computing, and enterprise software. Their teams build intelligent solutions for industries such as manufacturing, healthcare, and automation. As a Software Engineer at InvoZone, I worked on designing AI driven systems, backend services, and cloud native architectures that enhanced operational efficiency, predictive intelligence, and largescale data processing.",
    imgPath: exp4,
    logoPath: logo4,
    title: "Software Engineer",
    date: "2021 - 2023",
    responsibilities: [
      "Developed AI solutions for industrial automation by building and deploying machine learning models with TensorFlow and PyTorch, improving predictive accuracy and operational intelligence.",
      "Engineered backend services using Django and FastAPI, integrated SQL/NoSQL data stores, and deployed scalable infrastructure across AWS, GCP, and Azure to support AI workloads.",
      "Implemented advanced ML lifecycle workflows including model monitoring, tuning, testing (Pytest/TDD), and production deployment to ensure high reliability, performance, and maintainability.",
    ],
  },
  {
    review: "Zmasta is a technology focused company specializing in intelligent digital solutions and interactive systems. At Zmasta, I contributed to building automation tools and computer vision–based features that enhanced user experience and improved system intelligence. My work involved developing image processing pipelines, interactive interfaces, and chatbot integrations to make the platform more dynamic and user centric.",
    imgPath: exp6,
    logoPath: logo6,
    title: "Associate Software Engineer",
    date: "2020 - 2021",
    responsibilities: [
      "Developed an image processing system using Python and OpenCV to detect and analyze changes across time based images, enabling automated visual monitoring and insight generation.",
      "Built and integrated an interactive chatbot that improved user engagement and allowed dynamic access to system information and features.",
      "Developed frontend interaction layers using JavaScript, creating responsive and user friendly interfaces that complemented the computer vision workflows.",
    ],
  },
];

const experiences = [
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: starbucks,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross functional teams including designers, product managers, and other developers to create high quality products.",
      "Implementing responsive design and ensuring cross browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React Native Developer",
    company_name: "Tesla",
    icon: tesla,
    iconBg: "#E6DEDD",
    date: "Jan 2021 - Feb 2022",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross functional teams including designers, product managers, and other developers to create high quality products.",
      "Implementing responsive design and ensuring cross browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Web Developer",
    company_name: "Shopify",
    icon: shopify,
    iconBg: "#383E56",
    date: "Jan 2022 - Jan 2023",
    points: [
      "Architected and maintained a scalable backend framework using FastAPI and PostgreSQL, enabling high throughput and low latency processing of complex datasets for real time applications.",
      "Designed and deployed cloud native data storage and pipeline solutions on AWS S3 and Google Cloud using Apache Airflow, real time synchronization via Firebase, and ensured high availability and reliability across services.",
      "Led the development and integration of full stack modules with Django, FastAPI, React.js and Next.js; mentored junior developers in coding best practices, streamlined CI/CD workflows with Docker, Kubernetes and GitHub Actions, and monitored production systems using Prometheus, Grafana and the ELK Stack.",
      "Implementing responsive design and ensuring cross browser compatibility.",
    ],
 },
  {
    title: "Full stack Developer",
    company_name: "Meta",
    icon: meta,
    iconBg: "#E6DEDD",
    date: "Jan 2023 - Present",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross functional teams including designers, product managers, and other developers to create high quality products.",
      "Implementing responsive design and ensuring cross browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
];

const testimonials = [
  {
    testimonial:
      "Quick shoutout to Hussnain, he handled the redesign really well. Kept us updated, fixed things fast and the final result looks clean. Good job, man.",
    name: "Alexey",
    designation: "CEO / Founder",
    company: "ReductStore",
    image: alexeyImg,
    isScreenshot: true,
  },
  {
    testimonial:
      "Just got their feedback. Client is really happy with the fix you did. Everything is working smoothly now. Good work 👍",
    name: "Sohaib Anwar",
    designation: "CTO",
    company: "Artilence",
    image: sohaibImg,
    isScreenshot: true,
  },
  {
    testimonial:
      "Great Work on the project. Delivered ahead of schedule and exceeded our expectations.",
    name: "Sebastian",
    designation: "Client",
    company: "InvoZone",
    isScreenshot: true,
    image: furqanImg,
  },
];

const projects = [
  {
    name: "Chopcast",
    description:
      "Chopcast is an AI powered content repurposing platform that automatically transforms long form videos, webinars, and podcasts into short, high engagement clips. It helps teams quickly extract highlights, generate captions, and create social ready content to boost productivity",
    tags: [
      {
        name: "python",
        color: "blue-text-gradient",
      },
      {
        name: "react",
        color: "green-text-gradient",
      },
      {
        name: "whisper ai",
        color: "pink-text-gradient",
      },
    ],
    image: chopcast,
    source_code_link: "https://github.com/",
  },
  {
    name: "FirstStep.ai",
    description:
      "FirstStep.ai builds on premise industrial AI systems for safety, inspection, and predictive maintenance. Their solutions analyze visual and sensor data in real time to detect defects, monitor equipment health, and improve operational efficiency across manufacturing and industrial environments.",
    tags: [
      {
        name: "python",
        color: "blue-text-gradient",
      },
      {
        name: "restapi",
        color: "green-text-gradient",
      },
      {
        name: "scss",
        color: "pink-text-gradient",
      },
    ],
    image: jobit,
    source_code_link: "https://github.com/",
  },
  {
    name: "NZDPU",
    description:
      "Net‑Zero Data Public Utility (NZDPU) is a global open data initiative designed to act as a freely accessible repository of company level climate transition information, providing transparent data on greenhouse gas emissions, reduction targets and methodological metadata.",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "supabase",
        color: "green-text-gradient",
      },
      {
        name: "python",
        color: "pink-text-gradient",
      },
    ],
    image: nzdpu,
    source_code_link: "https://github.com/",
  },
];

export { services, technologies, experiences, testimonials, projects, expCards };
